<template>
  <div>
    <div class="order-container">
      <div class="order-container-item" v-for="order in orderList" :key="order.orderId">
        <order-item :order="order" @showPopup="openPopup" isSplitOrder></order-item>
        <div class="btn-wrapper" v-if="isShowPickCode(order) || order.status === 0">
          <van-button
            v-if="isShowPickCode(order)"
            hairline
            round
            plain
            class="gory-btn btn"
            color="#D9D9D9"
            size="small"
            @click="openPopup(order)"
          >
            核销码
          </van-button>
          <van-button
            v-if="order.status === 0"
            hairline
            round
            plain
            class="gory-btn btn"
            color="#D9D9D9"
            size="small"
            @click="thirdPay(order)"
          >
            他人代付
          </van-button>
          <van-button
            style="margin-left: 8px"
            hairline
            round
            plain
            v-if="order.status === 0"
            class="btn"
            color="#1E8DFF"
            size="small"
            v-reClick="() => toPay(order)"
          >
            立即支付
          </van-button>
        </div>
      </div>
    </div>
    <van-popup round overlay-class="self-popup-overlay" class="self-popup-box" v-model="isShowPopup">
      <div class="popup-container">
        <p class="popup-container-title">请凭核销码取货</p>
        <p class="popup-container-code">{{ pickCode }}</p>

        <p class="popup-container-time">
          <span class="label">自提时间: &nbsp;</span>
          <span>&nbsp; {{ timeSection }}</span>
        </p>
      </div>
      <div style="margin-top: 24px; text-align: center">
        <van-icon @click="closePopup" color="#FFFFFF" name="cap-toastfail" size="24px" />
      </div>
    </van-popup>
  </div>
</template>
<script>
import utils from '@/util/index.js';
import orderItem from '../orderList/orderItem.vue';
import { Dialog } from '@zyf2e/capui-mobile';
import ZYPay from '@zyf2e/checkout-sdk';

export default {
  components: {
    orderItem
  },
  data() {
    return {
      orderList: [],
      isShowPopup: false,
      pickCode: '',
      timeSection: '',
      payLock: false
    };
  },
  created() {
    const { orderId } = this.$route.query;
    this.$fetch.getSupplyOrderDetail({ orderId }).then((res) => {
      this.orderList = res.providerOrderList;
    });
  },
  async mounted() {
    await ZYPay.init({
      ...util.ZYpayConfig
    });
  },
  methods: {
    async toPay(order) {
      if (this.payLock) {
        this.$toast('支付中，请勿重复点击')
        return
      }
      this.payLock = true
      // const tradeNo = await this.$fetch.fetchGetTradeNo({
      //   orderId: order.orderParentId || order.orderId
      // })
      // .then(res => {
      //   const tradeNo = res;
      //   const backParams = { orderId: order.orderId, prescription: order.orderType === 7 ? '1' : '2' };

      //   utils.payHandle.call(this, {
      //     tradeNo,
      //     backParams,
      //     channel: 'MEDIC_SALE'
      //   });
      // })
      // .catch(err => {
      //   this.$toast('系统开小差了，请稍后再试');
      // });
      const backParams = { orderId: order.orderId, prescription: order.orderType === 7 ? '1' : '2' };
      const payParams = {
        failUrl: encodeURIComponent(`${window.location.origin}#/payment/fail${util.parseParam(backParams)}`),
        successUrl: encodeURIComponent(`${window.location.origin}#/payment/success${util.parseParam(backParams)}`)
      };

      try {
        const { tradeNo = '' } = await this.$fetch.fetchGetTradeNo({
          orderId: order.orderParentId || order.orderId
        });
        await ZYPay.prePay({ tradeNo, ...payParams });
        this.payLock = false
      }catch(error) {
        this.payLock = false
        if (error === 'INIT_ADAPT_ERROR') {
          Dialog.confirm({
            title: '温馨提示',
            message: '支付环境异常,请刷新重试',
            confirmButtonText: '立即重试'
          })
            .then(() => {
              window.location.reload()
              // on confirm
            })
            .catch((action) => {
              // on cancel or assist
            });
            return
        }
        this.$toast(error && error.message ? error.message : error);
      }
      
    },
    thirdPay(order) {
      this.$router.push({
        name: 'thirdPay',
        query: {
          orderId: order.orderParentId || order.orderId
        }
      });
    },
    openPopup(order) {
      this.pickCode = order.pickCode;
      this.timeSection = order.timeSection;
      this.isShowPopup = true;
    },
    closePopup() {
      this.isShowPopup = false;
      // this.$nextTick(() => {
      //   this.pickCode = '';
      //   this.timeSection = '';
      // });
    },
    isShowPickCode(order = {}) {
      const isFatherOrder = order.subOrders && Array.isArray(order.subOrders) && order.subOrders.length > 0;
      return !isFatherOrder && order.deliveryWay === 2 && order.status === 12;
    }
  }
};
</script>
<style lang="less" scoped>
.order-container {
  padding: 12px;
  &-item {
    background: #fff;
    border-radius: 8px;
    padding: 0 12px;
    padding-top: 20px;
    margin-bottom: 12px;
  }
}
.btn-wrapper {
  text-align: right;
  background: #ffffff;
  padding-bottom: 16px;
  .btn {
    height: 32px;
  }
  .gory-btn {
    /deep/ .van-button__content {
      color: #595959;
    }
  }
  .btn-pay {
    width: 78px;
    height: 32px;
    border-radius: 8px;
    background: #1e8dff;
  }
}
.self-popup-box {
  background: transparent;
  .popup-container {
    width: 100%;
    padding: 36px 16px;
    background: #fff;
    border-radius: 12px;
    text-align: center;
    color: #262626;
    font-size: 14px;
    min-width: 270px;
    &-title {
      margin-bottom: 20px;
    }
    &-code {
      font-size: 32px;
      color: #1e8dff;
      font-weight: 500;
      margin-bottom: 32px;
    }
    &-time {
      width: 100%;
      font-size: 12px;
      color: #1e8dff;
      .label {
        color: #8c8c8c;
      }
    }
  }
}
</style>
